module.exports = __webpack_public_path__ + "img/Hero.0e6ed11f.png";